import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useIntl } from '@atlassian/jira-intl';
import type { Status } from '@atlassian/jira-version-modals/src/common/model/index.tsx';
import imageUrl from './assets/release.svg';
import messages from './messages.tsx';

type Props = {
	statusFilter: Status[];
	searchFilter: string;
};

export function Empty(props: Props): React.JSX.Element {
	const defaultDescriptionGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.defaultDescriptionGalaxia
		: messages.defaultDescription;
	const headerGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? messages.headerGalaxia
		: messages.header;
	const { formatMessage } = useIntl();

	const { statusFilter, searchFilter } = props;

	return (
		<EmptyState
			imageUrl={imageUrl}
			headingLevel={2}
			header={formatMessage(headerGalaxia)}
			description={formatMessage(
				!searchFilter && statusFilter.length > 0
					? messages.noMatchingStatusDescription
					: defaultDescriptionGalaxia,
			)}
		/>
	);
}

export default Empty;
